import {Fragment} from 'react'

import EditSettingsForm from '../../../../../components/EditSettingsForm/EditSettingsForm'

import PipelineRepositoryAutocomplete from './PipelineRepositoryAutocomplete/PipelineRepositoryAutocomplete'
import PipelineRepositoryBranch from './PipelineRepositoryBranch/PipelineRepositoryBranch'
import PipelineRepositoryBranchAutocomplete from './PipelineRepositoryBranchAutocomplete/PipelineRepositoryBranchAutocomplete'
import type {PipelineRepositoryFormProps} from './PipelineRepositoryForm.types'
import {excludedBranchesLabel, includedBranchesLabel} from './PipelineRepositoryForm.utils'
import usePipelineRepositoryForm from './usePipelineRepositoryForm'

import styles from './PipelineRepositoryForm.css'

function PipelineRepositoryForm({
  className,
  repositories,
  repositoryUrl = '',
  branch = '',
  isRoot = false,
  isCreateMode = false,
  included = '',
  excluded = '',
  onDelete,
  onConfirm,
}: PipelineRepositoryFormProps) {
  const {
    isExtendForm,
    includedDraft,
    excludedDraft,
    autocompleteSelectedValue,
    repositoryBranchValue,
    isInvalidForm,
    branchOptions,
    setIncludedDraft,
    setExcludedDraft,
    confirmHandler,
    repositoryAutocompleteChangeHandler,
    branchAutocompleteChangeHandler,
  } = usePipelineRepositoryForm(repositoryUrl, branch, included, excluded, onConfirm)
  const editSettingsFormTitle = `${isCreateMode ? 'Add' : 'Edit'} Repository`

  return (
    <EditSettingsForm
      disabled={isInvalidForm}
      onConfirmClick={confirmHandler}
      onDeleteClick={onDelete}
      title={editSettingsFormTitle}
      className={className}
    >
      <PipelineRepositoryAutocomplete
        repositories={repositories}
        disabled={isRoot}
        selected={autocompleteSelectedValue}
        onChange={repositoryAutocompleteChangeHandler}
      />
      {isExtendForm && (
        <Fragment>
          <PipelineRepositoryBranchAutocomplete
            onChange={branchAutocompleteChangeHandler}
            options={branchOptions}
            value={repositoryBranchValue}
          />
          <PipelineRepositoryBranch
            aria-label={'Included'}
            branches={branchOptions}
            label={includedBranchesLabel}
            value={includedDraft}
            onChange={setIncludedDraft}
          />
          <div className={styles.notice}>
            {'Patterns with * are supported. Leave empty to include all branches.'}
          </div>
          <PipelineRepositoryBranch
            branches={branchOptions}
            aria-label={'Excluded'}
            label={excludedBranchesLabel}
            value={excludedDraft}
            onChange={setExcludedDraft}
          />
          <div className={styles.notice}>{'Patterns with * are supported.'}</div>
        </Fragment>
      )}
    </EditSettingsForm>
  )
}

export default PipelineRepositoryForm
